import { ReportShapeItem, ShapeType } from '../../reportsTypes';
import * as z from 'zod';
import { geometrySchema } from '@ais-ui/utils';

export function createDynamicShapeZodSchema(
  shapeItems: ReportShapeItem[] | undefined,
  type: ShapeType,
  instantShape?: boolean | undefined
) {
  const schemaFields: Record<string, z.ZodTypeAny> = {};

  if (!shapeItems) {
    return z.object(schemaFields);
  }

  if (type === 'multiShape') {
    for (const shapeItem of shapeItems) {
      const minRequired = shapeItem.minItems ?? 1;
      const message = `${shapeItem.label ?? 'Shape'} requires at least ${minRequired} item${minRequired > 1 ? 's' : ''}`;
      // The string represents an id of a shape and the geometrySchema an ad hoc created shape
      schemaFields[shapeItem.name] = z
        .array(z.union([z.string().min(1, message), geometrySchema]))
        .min(minRequired, message);
    }
  } else if (type === 'worldShape') {
    for (const shapeItem of shapeItems) {
      schemaFields[shapeItem.name] = z.boolean();
    }
  } else if (type === 'ports') {
    for (const shapeItem of shapeItems) {
      const message = `${shapeItem.label ?? 'Shape'} is required`;
      schemaFields[shapeItem.name] = z
        .array(z.string().min(1, message))
        .min(1, message);
    }
  } else if (instantShape) {
    // For instant shapes: Accept Geometry OR empty string (before drawing)
    for (const shapeItem of shapeItems) {
      schemaFields[shapeItem.name] = z.union([
        geometrySchema,
        z.string().length(0), // Allow empty string before drawing
        z.null(),
      ]);
    }
  } else {
    for (const shapeItem of shapeItems) {
      const message = `${shapeItem.label ?? 'Shape'} is required`;
      schemaFields[shapeItem.name] = z.string().min(1, message);
    }
  }

  return z.object(schemaFields);
}
